import { useMutation } from '@tanstack/react-query';
import { JsonObject } from 'type-fest';

import { useRequest, type MutationFunction } from '../common';

export type UseCreateVendorRfqData = {
  groupBusinessName: string;
  id: number;
}[] &
  JsonObject;

export type UseCreateVendorRfqRequestVars = {
  quoteId: number;
  accountIds: number[];
  // Always sent explicitly: the API copies ALL items/files when a key is omitted
  quoteItemIds: number[];
  quoteFileUuids: string[];
  notes?: string;
};

export const VENDOR_RFQ_QUANTITY_BREAKS_ERROR_CODE =
  'vendor_rfq_quantity_breaks_exceeded';

export const useCreateVendorRfq: MutationFunction<
  UseCreateVendorRfqData,
  UseCreateVendorRfqRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/vendor_rfq`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
